import { IconAtom } from "../../atoms";
import styles from "./styles.module.scss";

interface Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function PaginationMolecule(props: Readonly<Props>) {
  let counter = 0;

  const getPages = (current: number, total: number): (number | "ellipsis")[] => {
    const pages: (number | "ellipsis")[] = [];

    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    pages.push(1);

    if (current > 3) {
      pages.push("ellipsis");
    }

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (current < total - 2) {
      pages.push("ellipsis");
    }

    pages.push(total);

    return pages;
  };

  return (
    <nav aria-label="Paginering">
      <ul className={styles.pagination}>
        <li>
          <button
            type="button"
            onClick={() => props.onPageChange(props.currentPage - 1)}
            disabled={props.currentPage === 1}
            aria-label="Vorige pagina"
          >
            <IconAtom icon="icon-cta-left" size="medium" aria-hidden="true" />
          </button>
        </li>

        {getPages(props.currentPage, props.totalPages).map((page) => {
          counter++;
          return page === "ellipsis" ? (
            <li key={`ellipsis-${counter}`} aria-hidden="true">
              …
            </li>
          ) : (
            <li key={page}>
              <button
                type="button"
                onClick={() => props.onPageChange(page)}
                aria-current={page === props.currentPage ? "page" : undefined}
              >
                {page}
              </button>
            </li>
          );
        })}

        <li>
          <button
            type="button"
            onClick={() => props.onPageChange(props.currentPage + 1)}
            disabled={props.currentPage === props.totalPages || props.totalPages === 0}
            aria-label="Volgende pagina"
          >
            <IconAtom icon="icon-cta-right" size="medium" aria-hidden="true" />
          </button>
        </li>
      </ul>
    </nav>
  );
}
